import * as api from '../../api';
import { pagingDataUtilities } from '../../common';

export const fetchListActions = api.fetchActions('dashboard-messages', 'fetch-messages');
export const fetchAllMessagesActions = api.fetchActions('dashboard-messages', 'fetch-all-messages');
export const pagingActions = pagingDataUtilities.pagingActions('dashboard-messages', 'paging');
export const dismissMessageActions = api.fetchActions('dashboard-messages', 'dismiss-messages');
export const fetchMessageStatsActions = api.fetchActions('dashboard-messages', 'fetch-stats');
export const recordMessagesViewedActions = api.fetchActions('dashboard-messages', 'view-messages');

export const actionTypes = {
  ...fetchListActions.actionTypes,
  ...fetchAllMessagesActions.actionTypes,
  ...dismissMessageActions.actionTypes,
  ...fetchMessageStatsActions.actionTypes,
  ...recordMessagesViewedActions.actionTypes,
  SET_DISMISS_TARGET : 'dashboard-messages.set-dismiss-target'
}

export const fetchList = (participantId) =>  api.getThunk(`/dashboard-messages/GetOpenDashboardMessages/${participantId}`, {}, fetchListActions);

export function fetchAllMessages(participantId) {
  return (dispatch, getState) => {
    const state = getState();
    const { dashboardMessages } = state;
    const { pagingData } = dashboardMessages;
    const { currentPage, itemsPerPage } = pagingData || {};
    const params = {
      page: currentPage,
      perPage: itemsPerPage
    };
    return dispatch(api.shouldExecute(['dashboardMessages', 'allMessagesState'],
      api.getThunk(`/dashboard-messages/GetOpenDashboardMessages/${participantId}`, params, fetchAllMessagesActions)));
  }
}

export const dismissMessage = (messageId) =>  api.shouldExecute(['messageDismissals', messageId],
  api.postThunk(`/dashboard-messages/dismiss/${messageId}`, {}, dismissMessageActions, {messageId}));

export const fetchStats = (participantId) =>  api.getThunk(`/dashboard-messages/stats/${participantId}`, {}, fetchMessageStatsActions);

export const recordMessagesViewed = () =>  api.postThunk(`/participants/view-messages`, {}, recordMessagesViewedActions);

export function setDismissTarget(messageId) {
  return {
    type : actionTypes.SET_DISMISS_TARGET,
    messageId
  }
}

export const changePageNumber = (page) => pagingDataUtilities.changePage(page, pagingActions);



// WEBPACK FOOTER //
// src/dashboard/messages/messages.actions.js